// Small immutable list helpers used by the editor.

export function moveItem<T>(list: T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export const removeItem = <T,>(list: T[], index: number): T[] => list.filter((_, i) => i !== index);

export const replaceItem = <T,>(list: T[], index: number, item: T): T[] =>
  list.map((existing, i) => (i === index ? item : existing));

/** Copies form values into an object, dropping empty optional fields. */
export function compact<T extends object>(values: Record<string, string>): T {
  const out: Record<string, string> = {};
  Object.entries(values).forEach(([key, value]) => {
    const trimmed = value.trim();
    if (trimmed) out[key] = trimmed;
  });
  return out as T;
}
